import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Deletes a recipient template file by its ID.
 *
 * Sends a DELETE request to the recipient template file endpoint using the provided Ky instance.
 *
 * @param instance - The Ky HTTP client instance to use for the request.
 * @param id - The unique identifier of the recipient template file to delete.
 * @returns A promise that resolves to the operation result of the deletion.
 * @throws Throws an error if the request fails.
 */
export const deleteRecipientTemplateFile = async (instance: KyInstance, id: number) => {
  try {
    return await instance.delete<OperationResult>(formatString(Uri.files.recipientTemplateFiles, id.toString())).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
